import { Box, SectionHelper, TextButton } from '@wix/design-system';
import React from 'react';
import {
  appMarketAppPageOneDependencyImpression,
  appMarketAppPageOneDependencyClick,
} from '@wix/bi-logger-app-market-data/v2';
import { useTranslation, useEssentials } from '@wix/app-market-core';
import { AppIncompatibleNotificationDataHooks } from './data-hooks';
import { StatusAlertSmall } from '@wix/wix-ui-icons-common/lazy';

export interface AppIncompatibleNotificationProps {
  appId: string;
  appName: string;
  onFindSimilarAppsClick(): void;
}

export function AppIncompatibleNotification({
  appId,
  appName,
  onFindSimilarAppsClick,
}: AppIncompatibleNotificationProps) {
  const { t } = useTranslation();
  const { biLogger } = useEssentials();

  React.useEffect(() => {
    biLogger.report(
      appMarketAppPageOneDependencyImpression({
        app_id: appId,
        dependency_type: 'not_supported',
        type: 'not_supported',
        app_dependency: undefined,
        refferal_info: 'standalone',
      }),
    );
  }, []);

  return (
    <SectionHelper
      dataHook={AppIncompatibleNotificationDataHooks.container}
      appearance="danger"
      title={t('app.page.incompatible.app.notification.title', {
        appName,
        interpolation: { escapeValue: false },
      })}
      fullWidth={true}
      size="small"
      showPrefixIcon
      prefixIcon={
        <Box padding="0 2px">
          <StatusAlertSmall />
        </Box>
      }
    >
      <TextButton
        dataHook={AppIncompatibleNotificationDataHooks.findSimilarAppsLink}
        size="small"
        underline="always"
        skin="dark"
        onClick={() => {
          biLogger.report(
            appMarketAppPageOneDependencyClick({
              app_id: appId,
              dependency_type: 'not_supported',
              type: 'not_supported',
              app_dependency: undefined,
              refferal_info: 'standalone',
              click_type: 'find_similar_apps',
            }),
          );
          onFindSimilarAppsClick();
        }}
      >
        {t('app.page.incompatible.app.notification.actionButtonText')}
      </TextButton>
    </SectionHelper>
  );
}
